var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.$store.state.showSpinner,"can-cancel":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }